import { render, staticRenderFns } from "./Pages.vue?vue&type=template&id=3de538f2"
import script from "./Pages.vue?vue&type=script&lang=ts"
export * from "./Pages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports